import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MuiBadge from '@material-ui/core/Badge';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { capitalize } from '@material-ui/core';

const MUI_COLORS = [
  'primary',
  'secondary',
];

export const COLORS = [
  ...MUI_COLORS,
  'alertRed',
  'accentGreen',
  'accentBlue',
  'accentBlue2',
  'accentRed2',
  'darkGray',
  'lightGray',
  'actionSelected',
  'primaryGray',
  'red',
  'orange',
  'seafoam',
];

const getColorProp = (color) => {
  if (MUI_COLORS.includes(color)) {
    return color;
  }

  return 'primary'; // Must be this or secondary to satisfy prop types
};

const getBadgeColor = (backgroundColor) => {
  return {
    backgroundColor,
  };
};

const useCustomStyles = makeStyles(theme => ({
  badgeColorAccentBlue: getBadgeColor(theme.palette.facet.accentBlue),
  badgeColorAccentBlue2: getBadgeColor(theme.palette.facet.accentBlue2),
  badgeColorDarkGray: getBadgeColor(theme.palette.facet.darkGray),
  badgeColorLightGray: getBadgeColor(theme.palette.facet.lightGray),
  badgeColorActionSelected: getBadgeColor(theme.palette.facet.actionSelected),
  badgeColorPrimaryGray: getBadgeColor(theme.palette.facet.primaryGray),
  badgeColorRed: getBadgeColor(theme.palette.facet.red),
  badgeColorAlertRed: getBadgeColor(theme.palette.facet.alertRed),
  badgeColorOrange: getBadgeColor(theme.palette.facet.orange),
  badgeColorSeafoam: getBadgeColor(theme.palette.facet.seafoam),
  badgeColorAccentGreen: getBadgeColor(theme.palette.facet.accentGreen),

  standaloneRoot: {
    display: 'flex',
  },
  standaloneBadge: {
    display: 'inline-flex',
    position: 'static',
    transform: 'none',
  },
}));

const styles = () => ({
  root: {},
  badge: {},
  colorPrimary: {},
  colorSecondary: {},
  colorError: {},
  dot: {},
  anchorOriginTopRightRectangle: {},
  anchorOriginBottomRightRectangle: {},
  anchorOriginTopLeftRectangle: {},
  anchorOriginBottomLeftRectangle: {},
  anchorOriginTopRightCircle: {},
  anchorOriginBottomRightCircle: {},
  anchorOriginTopLeftCircle: {},
  anchorOriginBottomLeftCircle: {},
  invisible: {},
});

const Badge = React.forwardRef((props, ref) => {
  const {
    className,
    classes,
    color,
    standalone,
    ...rest
  } = props;

  const {
    root: rootClass,
    badge: badgeClass,
    ...restClasses
  } = classes;

  const customClasses = useCustomStyles();

  return (
    <MuiBadge
      {...rest}
      ref={ref}
      max={99 /* Show 99+ instead of 100, 101, etc because otherwise you can push things too far */}
      classes={{
        ...restClasses,
        root: classNames(rootClass, className, { [customClasses.standaloneRoot]: standalone }),
        badge: classNames(badgeClass, customClasses[`badgeColor${capitalize(color)}`], { [customClasses.standaloneBadge]: standalone }),
      }}
      color={getColorProp(color)}
    />
  );
});

Badge.defaultProps = {
  className: '',
  color: 'alertRed',
  standalone: false,
};

Badge.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(COLORS),
  standalone: PropTypes.bool, // Renders the badge by itself
};

export default withStyles(styles)(Badge);
